import React from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";

export const ScreenContext = React.createContext<
  | {
      paymentMethod: PaymentMethod;
    }
  | undefined
>(undefined);
